import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { Token } from '@angular/compiler';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then((m) => m.HomePageModule),
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/profile/profile.module').then((m) => m.ProfilePageModule),
  },
  {
    path: 'wallets',
    loadChildren: () => import('./pages/wallets/wallets.module').then((m) => m.WalletsPageModule),
  },
  {
    path: 'rewards',
    loadChildren: () => import('./pages/rewards/rewards.module').then((m) => m.RewardsPageModule),
  },
  {
    path: 'personal',
    loadChildren: () => import('./pages/personal/personal.module').then((m) => m.PersonalPageModule),
  },
  {
    path: 'privacy-security',
    loadChildren: () => import('./pages/privacy-security/privacy-security.module').then((m) => m.PrivacySecurityPageModule),
  },
  {
    path: 'activities',
    loadChildren: () => import('./pages/activities/activities.module').then((m) => m.ActivitiesPageModule),
  },
  {
    path: 'rewards/:_id',
    loadChildren: () => import('./pages/rewards/rewards.module').then((m) => m.RewardsPageModule),
  },
  {
    path: 'missions',
    loadChildren: () => import('./pages/events/events.module').then((m) => m.EventsPageModule),
  },
  {
    path: 'missions-list',
    loadChildren: () => import('./pages/events-list/events-list.module').then((m) => m.EventsListPageModule),
  },
  {
    path: 'missions/:uuid',
    loadChildren: () => import('./pages/challenge-details/challenge-details.module').then((m) => m.ChallengeDetailsPageModule),
  },
  {
    path: 'missions/:uuid/challenge/:challengeUuid',
    loadChildren: () => import('./pages/challenge-details/challenge-details.module').then((m) => m.ChallengeDetailsPageModule),
  },
  {
    path: 'missions/:uuid/challenges/:challengeUuid',
    loadChildren: () => import('./pages/challenge-details/challenge-details.module').then((m) => m.ChallengeDetailsPageModule),
  },
  {
    path: 'events',
    loadChildren: () => import('./pages/events/events.module').then((m) => m.EventsPageModule),
  },
  {
    path: 'events-list',
    loadChildren: () => import('./pages/events-list/events-list.module').then((m) => m.EventsListPageModule),
  },
  {
    path: 'events/:alias',
    loadChildren: () => import('./pages/challenge-details/challenge-details.module').then((m) => m.ChallengeDetailsPageModule),
  },
  {
    path: 'events/:alias/challenge/:challengeUuid',
    loadChildren: () => import('./pages/challenge-details/challenge-details.module').then((m) => m.ChallengeDetailsPageModule),
  },
  {
    path: 'events/:alias/challenges/:challengeUuid',
    loadChildren: () => import('./pages/challenge-details/challenge-details.module').then((m) => m.ChallengeDetailsPageModule),
  },
  {
    path: 'settings',
    loadChildren: () => import('./pages/settings/settings.module').then((m) => m.SettingsPageModule),
  },
  {
    path: 'terms-of-use',
    loadChildren: () => import('./pages/terms-of-use/terms-of-use.module').then((m) => m.TermsOfUsePageModule),
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./pages/privacy-policy/privacy-policy.module').then((m) => m.PrivacyPolicyPageModule),
  },
  {
    path: 'prizes',
    loadChildren: () => import('./pages/prizes/prizes.module').then((m) => m.PrizesPageModule),
  },
  {
    path: 'faq',
    loadChildren: () => import('./pages/faq/faq.module').then((m) => m.FaqPageModule),
  },
  {
    path: 'faq-details/:slug',
    loadChildren: () => import('./pages/faq-details/faq-details.module').then((m) => m.FaqDetailsPageModule),
  },
  {
    path: 'private-key',
    loadChildren: () => import('./pages/private-key/private-key.module').then((m) => m.PrivateKeyPageModule),
  },
  {
    path: 'opt-out',
    loadChildren: () => import('./pages/opt-out/opt-out.module').then((m) => m.OptOutPageModule),
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
